import { useAuth } from "../../../Navigation/Auth/ProvideAuth";
import { CheckInOutButtons } from "../RightSideBar";
import UpdatedHeader from "./components/UpdatedHeader";
import PageContent from "./components/PageContent";
import UpdatedSideBar from "./components/UpdatedSideBar";
import { ParentComponentWithSideBar } from "../ParentComponentWithSideBar";
import { UpdatedFooter } from "./components/UpdatedFooter";
import { Link, useHistory } from "react-router-dom";
import { PATH } from "../../../config";
import React, { useState } from "react";
import { FaHome, FaFileContract, FaFax, FaCalendarAlt } from "react-icons/fa";
import {
  BsBell,
  BsCloudUpload,
  BsFillFileEarmarkTextFill,
  BsFillGearFill,
  BsFillGrid3X3GapFill,
  BsFlower3,
  BsGear,
  BsGraphUp,
  BsGrid,
  BsJoystick,
  BsReply,
  BsSearch,
} from "react-icons/bs";

import { Footer } from "../Footer";
import {
  AiOutlineCaretLeft,
  AiOutlineTeam,
  AiOutlineUsergroupAdd,
} from "react-icons/ai";
import { Button, Form, Modal } from "react-bootstrap";
import { IMAGES } from "../../images";
import { useDispatch, useSelector } from "react-redux";
import { useCookies } from "react-cookie";
import { success, USER_REQUEST } from "../../../redux/actions/utilities";

function AppLayout({ children }) {
  let auth = useAuth();
  const [widthState, setWidthState] = useState("maxWidth-sidebar");
  const [clicked, setClicked] = useState(false);
  const upDateStateAction = () => {
    setClicked(!clicked);
  };

  const isEmployee = auth.user.userRoleId === 2;

  return (
    <div className="new-app-layout">
      {isEmployee && <CheckInOutButtons />}
      <div className="container-fluid">
        <div className="row flex-nowrap">
          <UpdatedSideBar />
          <div className="content w-100">
            <UpdatedHeader />
            <PageContent>{children}</PageContent>
            {/* <UpdatedFooter /> */}
            <SessionExpireModal />
          </div>
        </div>
      </div>
    </div>
  );
}
export default AppLayout;

function SessionExpireModal() {
  const dispatch = useDispatch();
  const { sessionExpire } = useSelector((state) => state.user);
  const [cookies, remove] = useCookies(["user"]);

  const reLogin = () => {
    window.localStorage.removeItem("pmsTokenExpiry");
    remove("user");
    dispatch(success(USER_REQUEST.SET_SESSION_EXPIRE_STATE, false));
  };

  return (
    <Modal
      size="sm"
      className="session-out-modal"
      centered
      show={sessionExpire}
    >
      <Modal.Body closeButton className="text-center mt-3">
        <h4>
          Session Expired
          <br />
          <br />
          {/* <span className="mt-2">
            Your current session has been expired, please login again to
            conitnue
          </span> */}
        </h4>
        <Button
          size="sm"
          className="mt-3"
          variant="primary"
          onClick={() => reLogin()}
        >
          Re-Login
        </Button>
      </Modal.Body>
    </Modal>
  );
}
